import { render, staticRenderFns } from "./RatingTypeList.vue?vue&type=template&id=0bb062db&"
import script from "./RatingTypeList.vue?vue&type=script&lang=js&"
export * from "./RatingTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports